import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { TableCard } from "@/components/ui/table-card";
import { VenueItem } from "./VenueItem";
import type { Venue } from "@/types";

interface VenueListProps {
  venues: Venue[];
}

const collator = new Intl.Collator("pl-PL", { sensitivity: "base" });

export function VenueList({ venues }: VenueListProps) {
  if (venues.length === 0) {
    return (
      <p className="text-center py-12 text-muted-foreground">
        Brak lokalizacji. Dodaj pierwszą lokalizację.
      </p>
    );
  }

  const sorted = [...venues].sort((a, b) => collator.compare(a.name, b.name));

  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Nazwa</TableHead>
            <TableHead>Adres</TableHead>
            <TableHead>Współrzędne</TableHead>
            <TableHead className="w-20">Akcje</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sorted.map((venue) => (
            <VenueItem key={venue.id} venue={venue} />
          ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}
